import dynamic from 'next/dynamic';
import type { NeedHelpSectionCheckoutProps } from './cart/needHelp';
import type { FooterProps } from './footer/Footer';
import type { FooterKeyLinksProps } from './footer/footerKeyLinks/FooterKeyLinks';
import type { NotificationBarProps } from './header/notificationBar/NotificationBar';
import type { MegaMenuProps } from './navigation/megaMenu/MegaMenu';

/* eslint-disable promise/prefer-await-to-then */

export const HeaderComponent = dynamic(() =>
  import(/* webpackChunkName: "HeaderComponent" */ './header/Header').then((mod) => mod.HeaderComponent),
);

export const MarketingMessage = dynamic(() =>
  import(/* webpackChunkName: "MarketingMessage" */ './header/MarketingMessage').then((mod) => mod.MarketingMessage),
);

export const NavigationBar = dynamic(() =>
  import(/* webpackChunkName: "NavigationBar" */ './header/navigationBar/NavigationBar').then(
    (mod) => mod.NavigationBar,
  ),
);

export const NotificationBar = dynamic<NotificationBarProps>(() =>
  import(/* webpackChunkName: "NotificationBar" */ './header/notificationBar/NotificationBar').then(
    (mod) => mod.NotificationBar,
  ),
);

export const PromotionalLinksNav = dynamic(() =>
  import(/* webpackChunkName: "PromotionalLinksNav" */ './header/PromotionalLinksNav').then(
    (mod) => mod.PromotionalLinksNav,
  ),
);

export const SubNav = dynamic(() =>
  import(/* webpackChunkName: "SubNav" */ './header/subNav/SubNav').then((mod) => mod.SubNav),
);

export const ScrollToTop = dynamic(() =>
  import(/* webpackChunkName: "ScrollToTop" */ './footer/scrollToTop/ScrollToTop').then((mod) => mod.ScrollToTop),
);

export const SmallFooterLinks = dynamic(() =>
  import(/* webpackChunkName: "SmallFooterLinks" */ './footer/SmallFooterLinks').then((mod) => mod.SmallFooterLinks),
);

export const FooterIconsBlock = dynamic(() =>
  import(/* webpackChunkName: "FooterIconsBlock" */ './footer/footerIconsBlock/FooterIconsBlock').then(
    (mod) => mod.FooterIconsBlock,
  ),
);

export const NewsletterSignUp = dynamic(() =>
  import(/* webpackChunkName: "NewsletterSignUp" */ './footer/newsletterSignUp/NewsletterSignUp').then(
    (mod) => mod.NewsletterSignUp,
  ),
);

export const FooterAccordion = dynamic(() =>
  import(/* webpackChunkName: "FooterAccordion" */ './footer/footerAccordion/FooterAccordion').then(
    (mod) => mod.FooterAccordion,
  ),
);

export const CategoryFeaturedCard = dynamic(() =>
  import(/* webpackChunkName: "CategoryFeaturedCard" */ './navigation/CategoryFeaturedCard').then(
    (mod) => mod.CategoryFeaturedCard,
  ),
);

export const MainLinksColumn = dynamic(() =>
  import(/* webpackChunkName: "MainLinksColumn" */ './footer/MainLinksColumn').then((mod) => mod.MainLinksColumn),
);

export const SiteSwitcher = dynamic(() =>
  import(/* webpackChunkName: "SiteSwitcher" */ './footer/SiteSwitcher').then((mod) => mod.SiteSwitcher),
);

export const FooterComponent = dynamic<FooterProps>(() =>
  import(/* webpackChunkName: "FooterComponent" */ './footer/Footer').then((mod) => mod.Footer),
);

export const MegaMenu = dynamic<MegaMenuProps>(() =>
  import(/* webpackChunkName: "MegaMenu" */ './navigation/megaMenu/MegaMenu').then((mod) => mod.MegaMenu),
);

export const HeaderNavigation = dynamic(() =>
  import(/* webpackChunkName: "HeaderNavigation" */ './navigation/headerNavigation/HeaderNavigation').then(
    (mod) => mod.HeaderNavigation,
  ),
);

export const AmpliencePaymentMethods = dynamic(() =>
  import(/* webpackChunkName: "AmpliencePaymentMethods" */ './paymentMethods/AmpliencePaymentMethods').then(
    (mod) => mod.AmpliencePaymentMethods,
  ),
);

export const MediaCarousel = dynamic(() =>
  import(/* webpackChunkName: "MediaCarousel" */ './carousel/MediaCarousel').then((mod) => mod.MediaCarousel),
);

export const EmptyBasket = dynamic(() =>
  import(/* webpackChunkName: "EmptyBasket" */ './cart/emptyBasket/EmptyBasket').then((mod) => mod.EmptyBasket),
);

export const PriceTooltip = dynamic(() =>
  import(/* webpackChunkName: "PriceTooltip" */ './tooltip/PriceTooltip').then((mod) => mod.PriceTooltip),
);

export const ProductCarousel = dynamic(() =>
  import(/* webpackChunkName: "ProductCarousel" */ './carousel/productCarousel/ProductCarousel').then(
    (mod) => mod.ProductCarousel,
  ),
);

export const FooterKeyLinks = dynamic<FooterKeyLinksProps>(() =>
  import(/* webpackChunkName: "FooterKeyLinks" */ './footer/footerKeyLinks/FooterKeyLinks').then(
    (mod) => mod.FooterKeyLinks,
  ),
);

export const TrendingCarousel = dynamic(() =>
  import(/* webpackChunkName: "TrendingCarousel" */ './carousel/TrendingCarousel').then((mod) => mod.TrendingCarousel),
);

export const SizeCalculator = dynamic(() =>
  import(/* webpackChunkName: "SizeCalculator" */ './sizeCalculator/SizeCalculator').then((mod) => mod.SizeCalculator),
);

export const ShippingSection = dynamic(() =>
  import(/* webpackChunkName: "ShippingSection" */ './shippingSection/ShippingSection').then(
    (mod) => mod.ShippingSection,
  ),
);

export const RelatedProductsCarousel = dynamic(() =>
  import(
    /* webpackChunkName: "RelatedProductsCarousel" */ './carousel/relatedProductsCarousel/RelatedProductsCarousel'
  ).then((mod) => mod.RelatedProductsCarousel),
);

export const SimpleAccordions = dynamic(() =>
  import(/* webpackChunkName: "SimpleAccordions" */ './simpleAccordions/SimpleAccordions').then(
    (mod) => mod.SimpleAccordions,
  ),
);

export const Spacer = dynamic(() =>
  import(/* webpackChunkName: "Spacer" */ './spacer/Spacer').then((mod) => mod.Spacer),
);

export const NeedHelpSectionCheckout = dynamic<NeedHelpSectionCheckoutProps>(() =>
  import(/* webpackChunkName: "NeedHelpSectionCheckout" */ './cart/needHelp').then(
    (mod) => mod.NeedHelpSectionCheckout,
  ),
);

/* eslint-enable promise/prefer-await-to-then */
